<template>
  <Radio v-bind="$attrs" v-on="$listeners">
    <slot>{{ text }}</slot>
    <PgTextTip v-if="tip" :text="tip"></PgTextTip>
  </Radio>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { Radio } from 'element-ui'
import { PgTextTip } from '../../text-tip/index'

defineProps({
  text: [String, Number],
  tip: String,
})
</script>
